import AddBoard from "../../Components/Modals/AddBoard";
import Table from "../../Components/Table";
import { deleteBoardById, getAllBoard } from "../../Services/MasterService";

const Board = () => {
    // name, state_id, status, logo, id
    const columns = [
        {
            label: "Name",
            value: "name"
        },
        {
            label: "State",
            value: "state_id"
        },

        {
            label: "Logo",
            value: "logo",
                        renderValue: (value) => {
                return (
                    <img width={70} src={value} alt="..." class="img-thumbnail"/>
                )
            }
        },
        {
            label: "Status",
            value: "status_name",
        }
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddBoard data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllBoard}
            columns={columns}
            title={"Board Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteBoardById}
        />
    );
}

export default Board;